import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Button} from '@/components/ui/button/Button'
import {Menu} from '@ariakit/react'
import styled, {css, CSSProperties} from 'styled-components'

export const StyledFileDropdownMenuSection = styled.div(
    ({theme: {spacing}}) => css`
        padding: ${spacing}px;
    `
)

const makeDropdonwItemBaseStyle = (spacing: number) => css`
    padding: ${spacing}px;
    width: 100%;
    justify-content: flex-start;
    font-weight: 400;
`

export const StyledFileDropdownMenuDisplayButton = styled(ButtonLink)(
    ({theme: {spacing, palette}}) => css`
        ${makeDropdonwItemBaseStyle(spacing)};
        color: ${palette.neutral[950]};
        &:hover {
            background-color: ${palette.neutral[50]};
            color: ${palette.neutral[950]};
        }
    `
)

export const StyledFileDropdownMenuDeleteButton = styled(Button)(
    ({theme: {spacing, palette}}) => css`
        ${makeDropdonwItemBaseStyle(spacing)};
        color: ${palette.danger[500]};
        &:hover {
            background-color: ${palette.neutral[50]};
            color: ${palette.danger[500]};
        }

        & > svg {
            fill: ${palette.danger[500]};
        }
    `
)

export const StyledFileDropdownMenu = styled(Menu)(
    ({theme: {palette, shadows, typography}}) => css`
        background-color: ${palette.neutral['white']};
        border-radius: 8px;
        box-shadow: ${shadows.md};
        overflow: hidden;
        width: 140px;
        font-weight: 500;
        color: ${palette.neutral[700]};
        ${typography.textSm};
    `
)

export const StyledFileDropdownMenuTrigger = styled(Button)<{$width?: CSSProperties['width']}>(
    ({$width}) => css`
        width: ${$width || '100%'};
        justify-content: space-between;
        flex-shrink: 0;
        & > div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        & span {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `
)
